var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10089 30.4419C15.5292 33.5163 23.4626 31.9948 28.2554 26.284C33.9362 19.5153 33.0539 9.42452 26.2846 3.74561L21.7845 9.10755C27.073 13.5442 27.7623 21.4276 23.3242 26.7157C19.7854 30.9322 13.9589 32.34 9.10089 30.4419",
    fill: "url(#paint0_linear_204_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10089 30.4419C15.5292 33.5163 23.4626 31.9947 28.2554 26.284C28.8424 25.5846 29.3591 24.8497 29.8067 24.0879C30.5636 19.3846 28.8991 14.4132 24.9837 11.1285C23.9889 10.2939 22.912 9.6216 21.7852 9.10815C27.073 13.5449 27.7621 21.4279 23.3242 26.7157C19.7854 30.9322 13.9589 32.34 9.10089 30.4419Z",
    fill: "url(#paint1_linear_204_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8991 1.55802C16.4708 -1.51638 8.5374 0.00510214 3.74456 5.71583C-1.93626 12.4846 -1.05391 22.5754 5.71532 28.2543L10.2154 22.8923C4.92697 18.4557 4.23765 10.5723 8.67578 5.28417C12.2146 1.06767 18.0411 -0.340181 22.8991 1.55802",
    fill: "url(#paint2_linear_204_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8991 1.55802C16.4708 -1.51638 8.53741 0.00510214 3.74457 5.71583C3.15756 6.41524 2.64087 7.15015 2.19331 7.91193C1.4364 12.6153 3.10091 17.5866 7.01631 20.8714C8.01109 21.7059 9.08798 22.3783 10.2147 22.8917C4.92695 18.455 4.23785 10.572 8.67579 5.28417C12.2146 1.06767 18.0411 -0.340181 22.8991 1.55802",
    fill: "url(#paint3_linear_204_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_3",
    x1: 27.6068,
    y1: 20.5955,
    x2: 20.8086,
    y2: 7.05293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF2131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_3",
    x1: 21.3844,
    y1: 9.10815,
    x2: 9.46698,
    y2: 29.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC52C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263921,
    stopColor: "#F87130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560797,
    stopColor: "#EF52E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661EEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_204_3",
    x1: 4.71012,
    y1: 11.5892,
    x2: 11.2259,
    y2: 24.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78F6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265705,
    stopColor: "#77D1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554471,
    stopColor: "#70A4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661EEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_204_3",
    x1: 10.8784,
    y1: 22.8917,
    x2: 22.7028,
    y2: 2.33144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246658,
    stopColor: "#54C3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#64D769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF2C"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwishIcon);
export default __webpack_public_path__ + "static/media/swish-icon.06a4ab016148e9759a2000ad5748c260.svg";
export { ForwardRef as ReactComponent };